// extracted by mini-css-extract-plugin
export default {"container":"YP-z","error":"ZP-z","disabled":"_P-z","submit":"aQ-z","option":"bQ-z","success":"cQ-z","failure":"dQ-z"};